import React from 'react';
import DashboardOverview from './DashboardOverview';

const Dashboard: React.FC = () => {
  return (
    <div className="p-6 lg:p-8">
      <div className="animate-fade-in">
        <DashboardOverview />
      </div>
    </div>
  );
};

export default Dashboard;